import { Menu, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import {commonIDs} from "../../qaIDs.json"

const useStyles = makeStyles(theme => ({
  menu: {
    width: 184
  },
  menuItem: {
    // padding: 0
    color: "#4D4D50",
    fontSize: "15px",
    fontWeight: 500
  },
  active: {
    color: theme.palette.primary.main
  },
  controlLabel: {
    margin: 0,
    height: theme.spacing(5),
    width: theme.spacing(23),
    padding: theme.spacing(0, 1)
  }
}));

export default function LanguageSelector({
  anchorEl,
  handleClose,
  language,
  setLanguage,
  menuProps
}: {
  anchorEl: null | Element;
  handleClose: () => void;
  language: string;
  setLanguage: (lng: string) => void;
  // TODO: possibility to use MenuProps interface
  menuProps: any;
}) {
  const classes = useStyles();

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      elevation={5}
      onClose={handleClose}
      classes={{
        list: classes.menu
      }}
      {...menuProps}
    >
      <MenuItem
        className={clsx(classes.menuItem, {
          [classes.active]: language === "en"
        })}
        id={commonIDs.languageOptionEn}
        onClick={() => {
          setLanguage("en");
          handleClose();
        }}
      >
        English
      </MenuItem>
      <MenuItem
        className={clsx(classes.menuItem, {
          [classes.active]: language === "nl"
        })}
        id={commonIDs.languageOptionDu}
        onClick={() => {
          setLanguage("nl");
          handleClose();
        }}
      >
        Nederlands
      </MenuItem>
      <MenuItem
        className={clsx(classes.menuItem, {
          [classes.active]: language === "de"
        })}
        id={commonIDs.languageOptionDe}
        onClick={() => {
          setLanguage("de");
          handleClose();
        }}
      >
        Deutsch
      </MenuItem>
    </Menu>
  );
}
